declare global {
  interface Window {
    runConfig: {
      frontendUrl: string;
      backendUrl: string;
      geoserverUrl: string;
      tapisWMTSUrl: string;
      dapUrl: string;
      nodeEnv: string;
      captchaSiteKey: string;
      enableInspireValidationOnPublish: boolean;
      disableAuthentication?: boolean;
      municipalProjectSelectedYear: string;
      paginationPageSize: number;
    };
  }
}

export const routes = {
  api: {
    frontendUrl: window?.runConfig?.frontendUrl,
    baseUrl: window?.runConfig?.backendUrl,
  },
  geo: {
    geoserverUrl: window?.runConfig?.geoserverUrl,
    tapisWMTSUrl: window?.runConfig?.tapisWMTSUrl,
    dapUrl: window?.runConfig?.dapUrl,
    municipalProjectSelectedYear: window?.runConfig.municipalProjectSelectedYear,
    paginationPageSize: window?.runConfig?.paginationPageSize,
  },
};

export const siteKey = window?.runConfig?.captchaSiteKey;

export const listStatuses = [
  {
    treeJsonTitle: 'Apspriešanā',
    searchStatus: 'pending_approval',
    title: 'Apspriešanā',
    shortTitle: 'Aps',
    color: 'red',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Publicēts pirms apspriešanas',
    searchStatus: 'before_public_discussion',
    title: 'Publicēts pirms apspriešanas',
    shortTitle: 'PPA',
    color: 'red',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Apspriešana beigusies',
    searchStatus: 'completed_public_discussion',
    title: 'Apspriešana beigusies',
    shortTitle: 'ApB',
    color: 'red',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Izstrāde',
    searchStatus: 'draft',
    title: 'Izstrāde',
    shortTitle: 'Izs',
    color: 'orange',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: true,
  },
  {
    treeJsonTitle: 'Jaunas redakcijas izstrāde',
    searchStatus: 'draft_new',
    title: 'Jaunas redakcijas izstrāde',
    shortTitle: 'JRI',
    color: 'orange',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: true,
  },
  {
    treeJsonTitle: 'Redakcionālu kļūdu labošana',
    searchStatus: 'small_changes',
    title: 'Redakcionālu kļūdu labošana',
    shortTitle: 'RKL',
    color: 'orange',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: true,
  },
  {
    treeJsonTitle: 'Atcelšana daļā',
    searchStatus: 'cancellation_in_part',
    title: 'Atcelšana daļā',
    shortTitle: 'AtD',
    color: 'green',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: true,
  },
  {
    treeJsonTitle: 'Apstiprināts',
    searchStatus: 'approved',
    title: 'Apstiprināts',
    shortTitle: 'Aps',
    color: 'green',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Spēkā (nav piemērojams)',
    searchStatus: 'active_not_applicable',
    title: 'Spēkā (nav piemērojams)',
    shortTitle: 'SNP',
    color: 'green',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Spēkā',
    searchStatus: 'active',
    title: 'Spēkā',
    shortTitle: 'Spē',
    color: 'green',
    identify: false,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Spēkā (izstrādāts uz teritorijas plānojuma, kurš zaudējis spēku)',
    searchStatus: 'active_historical',
    title: 'Spēkā',
    shortTitle: 'Spē',
    color: 'green',
    identify: true,
    useInSearch: false,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Zaudējis spēku',
    searchStatus: 'inactive',
    title: 'Zaudējis spēku',
    shortTitle: 'ZaS',
    color: 'gray',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Izstrāde apturēta',
    searchStatus: 'suspended',
    title: 'Izstrāde apturēta',
    shortTitle: 'IzA',
    color: 'gray',
    identify: true,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Darba redakcija',
    searchStatus: 'working_version',
    title: 'Darba redakcija',
    shortTitle: '',
    color: 'gray',
    identify: true,
    useInSearch: false,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Anulēts',
    searchStatus: 'closed',
    title: 'Anulēts',
    shortTitle: '',
    color: 'red',
    identify: false,
    useInSearch: false,
    identifyWhenMakingDecision: false,
  },
  {
    treeJsonTitle: 'Atcelts',
    searchStatus: 'cancelled',
    title: 'Atcelts',
    shortTitle: 'Atc',
    color: 'gray',
    identify: false,
    useInSearch: true,
    identifyWhenMakingDecision: false,
  },
];

export const cookieTypes = [
  {
    cookie: 'cookie',
    group: 'Nepieciešams',
    description: 'Reģistrē, kādas sīkdatnes lietotājs ir apstiprinājis.',
    deadline: '1 gads',
  },
  {
    cookie: 'laravel_session',
    group: 'Nepieciešams',
    description: 'Sesijas uzturēšanai un drošībai',
    deadline: 'Sesija',
  },
  {
    cookie: 'NOTIFICATION',
    group: 'Nepieciešams',
    description: 'Neradīt notifikācijas, ko lietotājs ir redzējis un aizvēris',
    deadline: '1 gads',
  },
  {
    cookie: '_ga',
    group: 'Statistikas sīkdatnes (nepieciešamas,lai uzlabotu vietnes darbību un pakalpojumus)',
    description: 'Google Analytics (analytics.js) unikālo apmeklējumu uzskaite',
    deadline: '2 gadi',
  },
  {
    cookie: '_gat',
    group: 'Statistikas sīkdatnes (nepieciešamas,lai uzlabotu vietnes darbību un pakalpojumus)',
    description: 'Google Analytics (analytics.js) pieprasījumu biežuma regulēšana',
    deadline: '10 minūtes',
  },
  {
    cookie: '__utma',
    group: 'Statistikas sīkdatnes (nepieciešamas,lai uzlabotu vietnes darbību un pakalpojumus)',
    description: 'Google analytics (ga.js) unikālo apmeklējumu uzskaite',
    deadline: '2 gadi',
  },
  {
    cookie: '__utmt',
    group: 'Statistikas sīkdatnes (nepieciešamas,lai uzlabotu vietnes darbību un pakalpojumus)',
    description: 'Google analytics (ga.js) pieprasījumu biežuma regulēšana',
    deadline: '10 minūtes',
  },
  {
    cookie: '__utmb',
    group: 'Statistikas sīkdatnes (nepieciešamas,lai uzlabotu vietnes darbību un pakalpojumus)',
    description: 'Google analytics (ga.js) pirmā apmeklējuma identificēšana',
    deadline: '30 minūtes',
  },
  {
    cookie: '__utmz',
    group: 'Statistikas sīkdatnes (nepieciešamas,lai uzlabotu vietnes darbību un pakalpojumus)',
    description: 'Google analytics (ga.js) apmeklējuma izcelsmes identificēšana.',
    deadline: '6 mēneši',
  },
];
